import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="forms--character-limit-feedback"
export default class extends Controller {
  static targets = ["field", "feedback"];
  static values = { limit: Number };

  connect() {
    this.showFeedback();
  }

  showFeedback() {
    const length = this.fieldTarget.value.length;
    const difference = this.limitValue - length;

    this.feedbackTarget.innerText = `${length}/${this.limitValue} characters`;

    this.feedbackTarget.classList.toggle("hidden", length === 0);

    if (difference > 10) {
      if (this.feedbackTarget.classList.contains("text-orange-600")) {
        this.feedbackTarget.classList.remove("text-orange-600");
      }
      if (this.feedbackTarget.classList.contains("text-red-600")) {
        this.feedbackTarget.classList.remove("text-red-600");
      }
      this.feedbackTarget.classList.add("text-green-600");
    } else if (difference > 0 && difference < 10) {
      if (this.feedbackTarget.classList.contains("text-green-600")) {
        this.feedbackTarget.classList.remove("text-green-600");
      }
      if (this.feedbackTarget.classList.contains("text-red-600")) {
        this.feedbackTarget.classList.remove("text-red-600");
      }
      this.feedbackTarget.classList.add("text-orange-600");
    } else {
      if (this.feedbackTarget.classList.contains("text-green-600")) {
        this.feedbackTarget.classList.remove("text-green-600");
      }
      if (this.feedbackTarget.classList.contains("text-orange-600")) {
        this.feedbackTarget.classList.remove("text-orange-600");
      }
      this.feedbackTarget.classList.add("text-red-600");
    }
  }
}
